import { render } from "./DriverDetail.vue?vue&type=template&id=12bec2e8"
import script from "./DriverDetail.vue?vue&type=script&lang=js"
export * from "./DriverDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__